/**
 * Cale SVG NETEZITĂ prin interpolare monotone-cubic (Fritsch–Carlson).
 *
 * De ce monotone și nu Catmull-Rom/bezier simplu: pe date financiare, un spline
 * clasic face „overshoot" — inventează vârfuri și gropi care NU există în date
 * (ex. o linie care coboară la 0 ar părea că intră pe minus). Varianta monotonă
 * garantează că între două puncte curba rămâne în intervalul valorilor lor:
 * arată neted/profesional, dar spune adevărul.
 */
export function buildSmoothPath(pts: Array<{ x: number; y: number }>): string {
  const n = pts.length;
  const r = (v: number) => Math.round(v * 100) / 100;
  if (n === 0) return '';
  if (n === 1) return `M${r(pts[0]!.x)},${r(pts[0]!.y)}`;
  if (n === 2) return `M${r(pts[0]!.x)},${r(pts[0]!.y)} L${r(pts[1]!.x)},${r(pts[1]!.y)}`;

  const dx: number[] = [];
  const slope: number[] = [];
  for (let i = 0; i < n - 1; i++) {
    const d = pts[i + 1]!.x - pts[i]!.x;
    dx.push(d);
    slope.push(d === 0 ? 0 : (pts[i + 1]!.y - pts[i]!.y) / d);
  }

  // Tangente Fritsch–Carlson: 0 la extreme locale (semne opuse), medie armonică
  // ponderată în rest — condiția de monotonie per segment.
  const tan: number[] = [slope[0]!];
  for (let i = 1; i < n - 1; i++) {
    const a = slope[i - 1]!;
    const b = slope[i]!;
    if (a * b <= 0) {
      tan.push(0);
    } else {
      const w1 = 2 * dx[i]! + dx[i - 1]!;
      const w2 = dx[i]! + 2 * dx[i - 1]!;
      tan.push((w1 + w2) / (w1 / a + w2 / b));
    }
  }
  tan.push(slope[n - 2]!);

  let d = `M${r(pts[0]!.x)},${r(pts[0]!.y)}`;
  for (let i = 0; i < n - 1; i++) {
    const h = dx[i]! / 3;
    d +=
      ` C${r(pts[i]!.x + h)},${r(pts[i]!.y + h * tan[i]!)}` +
      ` ${r(pts[i + 1]!.x - h)},${r(pts[i + 1]!.y - h * tan[i + 1]!)}` +
      ` ${r(pts[i + 1]!.x)},${r(pts[i + 1]!.y)}`;
  }
  return d;
}
